import React from 'react'

import { BurgerMenu } from 'components/BurgerMenu'
import {
  SectionedProgressBar,
  useSectionedProgress,
} from 'components/SectionedProgressBar'

import { useCohortInfo } from 'hooks/useCohortInfo'
import { useIsEnhancedPostPaymentFlow } from 'hooks/useIsEnhancedPostPaymentFlow'
import { usePageConfig } from 'hooks/usePageConfig'

import { StyledHeaderV2 as S } from './HeaderV2.styles'
import {
  COHORTS_WITH_BURGER_MENU,
  HEADER_BORDER_COLOR,
  THeaderVariant,
} from './constants'

type THeaderV2Props = {
  variant: THeaderVariant
}

export const HeaderV2: React.FC<THeaderV2Props> = ({ variant }) => {
  const {
    isBackButtonDisabled,
    headerBackground,
    headerTextColor,
    isHeaderOverlay,
    hasGlassHeader,
    headerTitle,
    isFirstPage,
    borderColor,
  } = usePageConfig()

  const { cohortToUse } = useCohortInfo()
  const { hasSectionedProgress } = useSectionedProgress()
  const isEnhancedPostPayment = useIsEnhancedPostPaymentFlow()

  const showBurgerMenu =
    isFirstPage && COHORTS_WITH_BURGER_MENU.includes(cohortToUse)

  const bottomBorderColor =
    borderColor || (isEnhancedPostPayment ? HEADER_BORDER_COLOR : '')

  return (
    <S.Wrapper
      $background={headerBackground}
      $isHeaderOverlay={isHeaderOverlay}
      $hasGlassEffect={hasGlassHeader && isHeaderOverlay}
      $borderColor={bottomBorderColor}
      $hasSectionedProgress={hasSectionedProgress}
    >
      {!isBackButtonDisabled && <S.HeaderBackButton />}

      {hasSectionedProgress ? (
        <SectionedProgressBar />
      ) : (
        <S.Text variant={variant} $textColor={headerTextColor}>
          {headerTitle}
        </S.Text>
      )}

      {showBurgerMenu && <BurgerMenu />}
    </S.Wrapper>
  )
}
